/*
  Menu da computer a tendina compatta (snippets/menu-computer.liquid).
  - Col mouse la tendina si apre dopo 150 ms fermi sulla voce: abbastanza per non scattare
    passando sopra la barra, abbastanza poco da sembrare immediata (con 300 ms, il valore
    di Baymard, l'utente la trovava lenta); a tendina aperta si passa da una voce all'altra
    in 80 ms, per non cambiare tendina tagliando in diagonale.
  - Si chiude 250 ms dopo che il mouse ha lasciato voce e tendina, con Esc o con un clic
    fuori. Da tastiera si apre quando la voce riceve il fuoco.
  - Sui touch (iPad in orizzontale) il primo tocco apre la tendina, il secondo porta alla
    categoria.
  - Se la tendina uscirebbe dallo schermo a destra, si sposta a sinistra quanto basta.
*/
if (!customElements.get('menu-computer')) {
  class MenuComputer extends HTMLElement {
    connectedCallback() {
      this.aperta = null;
      this.voci = Array.from(this.querySelectorAll('[data-mc-voce]'));

      this.voci.forEach((voce) => {
        const link = voce.querySelector('[data-mc-apri]');
        voce.addEventListener('mouseenter', () => this.entra(voce));
        voce.addEventListener('mouseleave', () => this.esce(voce));
        voce.addEventListener('focusin', () => this.apri(voce));
        voce.addEventListener('focusout', (event) => {
          if (!voce.contains(event.relatedTarget)) this.chiudi();
        });
        link.addEventListener('pointerdown', (event) => {
          this.tocco = event.pointerType === 'touch';
        });
        link.addEventListener('click', (event) => {
          if (this.tocco && this.aperta !== voce) {
            event.preventDefault();
            this.apri(voce);
          }
        });
      });

      // Passando su una voce senza tendina (NOVITA', Blog, SCONTI) quella aperta si chiude
      this.querySelectorAll('.mc-barra > li:not([data-mc-voce])').forEach((voce) =>
        voce.addEventListener('mouseenter', () => this.chiudi())
      );

      this.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape' || !this.aperta) return;
        const link = this.aperta.querySelector('[data-mc-apri]');
        this.chiudi();
        link.focus();
      });

      this.onClickFuori = (event) => {
        if (this.aperta && !this.contains(event.target)) this.chiudi();
      };
      document.addEventListener('click', this.onClickFuori);

      // Posizione calcolata subito e a ogni ridimensionamento: anche chiuse, le tendine
      // non devono uscire dallo schermo (allargherebbero la pagina)
      this.onResize = () => {
        clearTimeout(this.timerMisura);
        this.timerMisura = setTimeout(() => this.posizionaTutte(), 150);
      };
      window.addEventListener('resize', this.onResize);
      this.posizionaTutte();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onClickFuori);
      window.removeEventListener('resize', this.onResize);
      this.fermaTimer();
    }

    posizionaTutte() {
      this.voci.forEach((voce) => this.posiziona(voce.querySelector('[data-mc-tendina]')));
    }

    posiziona(tendina) {
      // offsetLeft/offsetWidth ignorano le trasformazioni: la misura vale anche mentre la
      // tendina si sta muovendo (getBoundingClientRect darebbe la posizione a meta' strada)
      const margine = 16;
      const destra = tendina.parentElement.getBoundingClientRect().left + tendina.offsetLeft + tendina.offsetWidth;
      const oltre = destra - (document.documentElement.clientWidth - margine);
      tendina.style.setProperty('--mc-sposta', oltre > 0 ? `-${Math.ceil(oltre)}px` : '0px');
    }

    fermaTimer() {
      clearTimeout(this.timerApri);
      clearTimeout(this.timerChiudi);
    }

    entra(voce) {
      this.fermaTimer();
      if (this.aperta === voce) return;
      this.timerApri = setTimeout(() => this.apri(voce), this.aperta ? 80 : 150);
    }

    esce(voce) {
      clearTimeout(this.timerApri);
      if (this.aperta !== voce) return;
      this.timerChiudi = setTimeout(() => this.chiudi(), 250);
    }

    apri(voce) {
      this.fermaTimer();
      if (this.aperta === voce) return;
      if (this.aperta) this.nascondi(this.aperta);
      this.aperta = voce;

      this.posiziona(voce.querySelector('[data-mc-tendina]'));
      voce.classList.add('is-aperta');
      voce.querySelector('[data-mc-apri]').setAttribute('aria-expanded', 'true');
    }

    nascondi(voce) {
      voce.classList.remove('is-aperta');
      voce.querySelector('[data-mc-apri]').setAttribute('aria-expanded', 'false');
    }

    chiudi() {
      this.fermaTimer();
      if (!this.aperta) return;
      this.nascondi(this.aperta);
      this.aperta = null;
    }
  }

  customElements.define('menu-computer', MenuComputer);
}
